// src/store/upload/uploadSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeUploads: [], // Array of { id, status, progress, abortController, metadata }
};

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    addUpload: (state, action) => {
      const { id, metadata } = action.payload;
      state.activeUploads.push({
        id,
        status: 'uploading', // 'uploading', 'completed', 'failed', 'cancelled'
        progress: 0,
        metadata,
        startTime: Date.now(),
      });
    },
    updateUploadProgress: (state, action) => {
      const { id, progress } = action.payload;
      const upload = state.activeUploads.find((u) => u.id === id);
      if (upload) {
        upload.progress = progress;
      }
    },
    completeUpload: (state, action) => {
      const { id, fileUrl } = action.payload;
      const upload = state.activeUploads.find((u) => u.id === id);
      if (upload) {
        upload.status = 'completed';
        upload.progress = 100;
        upload.fileUrl = fileUrl;
      }
    },
    failUpload: (state, action) => {
      const { id, error } = action.payload;
      const upload = state.activeUploads.find((u) => u.id === id);
      if (upload) {
        upload.status = 'failed';
        upload.error = error;
      }
    },
    cancelUpload: (state, action) => {
      const { id } = action.payload;
      const upload = state.activeUploads.find((u) => u.id === id);
      if (upload) {
        upload.status = 'cancelled';
      }
    },
    removeUpload: (state, action) => {
      const { id } = action.payload;
      state.activeUploads = state.activeUploads.filter((u) => u.id !== id);
    },
    setAbortController: (state, action) => {
      const { id, abortController } = action.payload;
      const upload = state.activeUploads.find((u) => u.id === id);
      if (upload) {
        upload.abortController = abortController;
      }
    },
  },
});

export const {
  addUpload,
  updateUploadProgress,
  completeUpload,
  failUpload,
  cancelUpload,
  removeUpload,
  setAbortController,
} = uploadSlice.actions;

// Selectors
export const selectActiveUploads = (state) => state.upload.activeUploads;
export const selectActiveUploadsCount = (state) =>
  state.upload.activeUploads.filter((u) => u.status === 'uploading').length;
export const selectUploadById = (id) => (state) =>
  state.upload.activeUploads.find((u) => u.id === id);

export default uploadSlice.reducer;
